module.exports = __webpack_public_path__ + "static/marykay_company-ab462c152a32031d5a4248c27409bf25.svg";